import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify);


import VueMq from 'vue-mq';

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 500,
    md: 1100,
    lg: Infinity,
  },
  defaultBreakpoint: 'sm' // customize this for SSR
});

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#347f7f",
        secondary: "#bcd382", //'#9abf74',
        accent: "#bfffe6", //'#f5ea4c',
        error: colors.deepOrange.darken3,
        warning: colors.orange.base,
        info: "#96bfe6", //colors.lightBlue.base,
        success: colors.green.base,
      },
    },
    options: {
      customProperties: true
    }
  },
});
